import { initModules } from "utils";
import Nav from "@/assets/js/modules/navigation";

initModules({
    Nav
})